<h3 *ngIf="data.id == null" mat-dialog-title>Criar Nova Pasta</h3>
<h3 *ngIf="data.id != null" mat-dialog-title>Alterar Pasta</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%">
                <input 
                    matInput 
                    placeholder="Nome" 
                    [formControl]="nome" 
                    required
                    maxlength="255">
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>